import React from "react";
import { Translate as T } from "react-redux-i18n";
import styles from "./CheckFeatures.css";
import { hasClientFeature } from "../../helpers/client";

const CheckFeatures = ({ children = null, required = [] }) => {
  const compatible = required.every(hasClientFeature);

  if (compatible) {
    return children;
  }

  return (
    <div className={styles.warning}>
      <h1>
        <T value={"checkFeatures.title"} />
      </h1>
      <p>
        <T value={"checkFeatures.body"} />
      </p>
      <p>
        <a href="http://outdatedbrowser.com/">
          <T value={"checkFeatures.link"} />
        </a>
      </p>
    </div>
  );
};

export default CheckFeatures;



// WEBPACK FOOTER //
// ./src/components/CheckFeatures/CheckFeatures.js